import { Icon } from '../../elements/icon';
import { Text } from '../../elements/text';
import {
  Spin,
  LoadingCard,
  LoadingContainer,
  LoadingBackground,
} from './circular-loading.styles';

export type CircularLoadingProps = {
  /**
   * Define se o componente está carregando
   * @type boolean
   * @default false
   */
  isLoading?: boolean;
  /**
   * Define se o componente deve exibir o texto de carregamento
   * @type boolean
   * @default true
   */
  hasText?: boolean;
  /**
   * Define o texto de carregamento
   * @type string
   * @default "Carregando..."
   */
  children?: string;
  /**
   * Define se o componente deve apresentar o efeito de modal (backdrop blur)
   * @type boolean
   * @default false
   */
  shouldBlur?: boolean;
};

export function CircularLoading({
  isLoading,
  hasText = true,
  children = 'Carregando...',
  shouldBlur = true,
}: Readonly<CircularLoadingProps>) {
  return isLoading ? (
    <LoadingContainer inline={!shouldBlur} data-testid="circular-loading">
      {shouldBlur && <LoadingBackground data-testid="background" />}
      <LoadingCard>
        <Spin>
          <Icon icon="circle-spinner" size={66} fill="#fff" />
        </Spin>
        {hasText && (
          <Text variant="Subtitle2" color="neutralVeryLight">
            {children}
          </Text>
        )}
      </LoadingCard>
    </LoadingContainer>
  ) : null;
}
